/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Pipe, PipeTransform } from '@angular/core';

/**
 * Filter search results, based on the searchtext entered.
 * @usageNotes
 * The following code shows how the pipe searchFilter can be used
 * @param items The list which is to be filtered.
 * @param searchBasedOn Class member on which it is searched.
 * @param searchText Text for searching.
 *
 */

@Pipe({
  name: 'searchFilterPipe'
})
export class SearchFilterPipe implements PipeTransform {

  transform(items: any[], searchBasedOn: string, searchText: string): any[] {
    /**
     * @param items The list which is to be filtered.
     * @param searchBasedOn Class member on which it is searched.
     * @param searchText Text for searching.
     */
    return this.searchFilter(items, searchBasedOn, searchText);
  }

  private searchFilter(items: any[], searchBasedOn: string, searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText || !searchBasedOn) {
      return items;
    }
    return items.filter(item => {
      return item[searchBasedOn].toLowerCase().includes(searchText.toLocaleLowerCase());
    });
  }
}
